import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

function DateInput({ className = '', value, onChange, min, max, id, disabled, 'aria-label': ariaLabel }) {
  return (
    <div className={`ios-date-wrap ${className}`.trim()}>
      <input
        id={id}
        type="date"
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={onChange}
        className="ios-date-input input-field"
      />
      <CalendarDaysIcon className="ios-date-icon pointer-events-none" aria-hidden="true" />
    </div>
  );
}

export default DateInput;
